module.exports = __webpack_public_path__ + "img/ic_home_salary@2x.f040763.png";